import React, {
    useEffect, useState, useCallback, useContext, useMemo, useRef
} from 'react';
import PropTypes from 'prop-types';
import { SearchService } from 'gw-capability-gateway';
import { useAuthentication, withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { MLActivityDateUtil } from 'ml-portals-util-react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import moment from 'moment';
import appConfig from 'app-config';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
import { MLBundleService, MLSearchDataHolderService, MLSearchTypesService, MLHVQBridgeService, MLStateRolloutService } from 'ml-services-common-react';
import { MLContactUtilsService } from 'ml-portals-services-js';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';
import {MLPortalSettingsService} from "gw-capability-quoteandbind";
import { platformMessages, FormModalPopover } from 'ml-components-platform-react';
import { MLQuoteNameUtil, MLPhoneFormatUtil, MLCapitalizeStringFilter } from 'ml-portals-util-js';
import bustfemale from 'ml-digital-theme-styles/images/cakeandarrow/svg/bust-female.svg';
import bustmale from 'ml-digital-theme-styles/images/cakeandarrow/svg/bust-male.svg';
import { Image, useModal } from '@jutro/components';
import { ViewModelForm, ViewModelServiceContext, withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import classNames from 'classnames';
import { Button } from '@jutro/legacy/components';
import { Link } from '@jutro/router';

import mlAccountsModalMessages from 'gw-capability-gateway-quoteandbind-common-react/components/MLPossibleAccountsModal/MLPossibleAccountsModal.messages';
import mlPossibleAccountsModal from 'gw-capability-gateway-quoteandbind-common-react/components/MLPossibleAccountsModal/MLPossibleAccountsModal.metadata.json5';
import mlAccountsModalStyles from 'gw-capability-gateway-quoteandbind-common-react/components/MLPossibleAccountsModal/MLPossibleAccountsModal.module.scss';
import mlBundleQuestionPopup from '../MLBundleQuestionPopup/MLBundleQuestionPopup';
import mlBundleQuestionPopupMsg from '../MLBundleQuestionPopup/MLBundleQuestionPopup.messages.js';

import metadata from './MLSearchResults.metadata.json5';
import styles from './MLSearchResults.module.scss';
import messages from './MLSearchResults.messages';

import { TooltipIcon  } from '@jutro/components';

const MAX_SEARCH_RESULT_DISPLAY = 10;
const LEGACY_SEARCH_INDEX = 2;
const lobNames = {
    'A': 'Auto',
    'H': 'Home',
    'U': 'Umbrella',
    'Y': 'Watercraft'
};

// workaround: callbacks from within modals are not picking up state or variable changes from within callbacks
let searchError

function MLSearchResults(props) {
    const modalApi = useModal();
    const {
        match,
        location,
        history
    } = props;

    const quoteID = _.get(location, 'state.quoteID');
    const searchParamAux = _.get(match, 'params.searchParam');
    const searchParam = searchParamAux && searchParamAux !== "undefined" ? searchParamAux : undefined;

    const forceReload = Date.now() + Math.random();

    const searchInput = MLSearchDataHolderService.getSearchInput();
    const initStateInput = MLSearchDataHolderService.getState();
    const initZipCodeInput = MLSearchDataHolderService.getZipCode();
    const initSearchBtnClicked = MLSearchDataHolderService.getSearchBtnClicked();

    const searchType = MLSearchDataHolderService.getSearchTypeCode();
    const isAcctNameSearch = MLSearchTypesService.isSearchTypeAcctName(searchType);
    const isPolicySearch = MLSearchTypesService.isSearchTypePolicy(searchType);
    const isJobSearch = MLSearchTypesService.isSearchTypeJob(searchType, searchParam);
    const isCompIDSearch = MLSearchTypesService.isSearchTypeCompRaterQuoteID(searchType, searchParam);
    const isJobAndZipCodeSearch = MLSearchTypesService.isSearchTypeCompRaterJobZipcode(searchType);

    let isPolicyNumSingleExactSearch = false;
    let isJobNumSingleExactSearch = false;
    let isHVQNumExactSearch = false;
    let isPolicyNumSingleSolrSearch = false;
    let isPortalSolrSearchEnabled = false;
    let isPortalSolrSingleTextSearchEnabled = false;

    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);
    const { onValidate } = useValidation('MLSearchResults');
    const {
        showErrorModal,
        showProgressDialog
    } = MLModalService();

    const {
        toLocaleTimeStamp
    } = MLActivityDateUtil();

    const { authHeader, authUserData } = useAuthentication();
    const { MLUserTypes } = appConfig;
    const isPCSorIA = authUserData.userType === MLUserTypes.PCS || authUserData.userType === MLUserTypes.IA;
    const stateList = viewModelService.productMetadata.get('pc').types.getTypelist('State');

    const [showModal, setShowModal] = useState(false);
    const [potentialExistingAccounts, setPotentialExistingAccounts] = useState([]);
    const [hvqTransactionId, setHvqTransactionId] = useState(undefined);
    const [pageConfig, setPageConfig] = useState({ "pageSize": MAX_SEARCH_RESULT_DISPLAY, "page": 0 });

    const createSearchRequest = () => {
        let reqObj = {};
        if (isAcctNameSearch) {
            reqObj = {
                name_ML: searchParam,
                state_ML: initStateInput,
                zipCode_ML: initZipCodeInput,
                country_ML: 'US'
            };
        } else if (isJobAndZipCodeSearch) {
            reqObj = {
                searchParam,
                zipCode_ML: initZipCodeInput
            };
        } else if (isPolicySearch) {
            reqObj = {
                searchParam: searchParam.charAt(0).toUpperCase() + searchParam.slice(1)
            };
        } else {
            reqObj = {
                searchParam
            };
        }
        return viewModelService.create(reqObj, 'pc', 'edge.capabilities.gateway.search.dto.SearchRequestDTO');
    };

    const initSearchRequest = createSearchRequest();
    const initSearchResult = {
        accounts: [],
        policies: [],
        message: undefined,
        arsMessage: undefined
    };
    const [loading, setLoading] = useState(true);
    const [redirectError, setRedirectError] = useState(false);
    const [searchRequest, setSearchRequest] = useState(initSearchRequest);
    const [searchResults, setSearchResults] = useState(initSearchResult);
    const [legacyPolicies, setLegacyPolicies] = useState([]);
    const [hasARSPolicies, setHasARSPolicies] = useState(false);
    const [searchHeader, setSearchHeader] = useState('');

    const [isInitPortalSolrSingleTextSearchEnabled, setIsInitPortalSolrSingleTextSearchEnabled] = useState(false);

    useEffect(() => {
        async function getPortalSettings() {

            MLPortalSettingsService.getSettings(authHeader).then((response) => {
                if (response) {
                    if (response.enablePortalSolrSingleTextSearch) {
                        setIsInitPortalSolrSingleTextSearchEnabled(true);
                    }
                }
            });
        }

        getPortalSettings();
    }, []);

    if (MLSearchDataHolderService.getSearchTypeChanged()) {
        // if search type changed, reinitialise searchResults to prevent error during change in datatable columns
        setSearchResults(initSearchResult);
        setLoading(true);
        MLSearchDataHolderService.setSearchTypeChanged(false);
    }

    const hasARSMessage = () => {
        if(legacyPolicies.length===0){
            return true
        }
    };

    const zipCodeRef = useRef(null);
    const stateRef = useRef(null);
    const copyResultsRef = useRef([]);

    const clearMLSearchDataHolderService = () => {
        MLSearchDataHolderService.clear();
    };

    const redirectQuote = (quoteId, postalCode) => {
        history.push('/quoteentry', { quoteID: quoteId, postalCode: postalCode });
    };

    const scrollTop = useCallback((event) => {
        event.preventDefault();
        window.scrollTo(0, 0);
    }, []);

    const setDataToDisplay = (data) => {
        setSearchResults({ ...searchResults, accounts: data });
    };

    const goToAccountSummaryPage = (accountNumber) => {
        if (!_.isUndefined(accountNumber)) {
            history.push(`/accounts/${accountNumber}/summary`);
        }
    };

    const goToPolicySummaryPage = (policyNumber) => {
        if (!_.isUndefined(policyNumber)) {
            history.push(`/policies/${policyNumber}/summary`);
        }
    };

    const goToSummaryPage = (item) => {
        return goToAccountSummaryPage(item.accountNumber);
    };

    const goToQuote = (jobNumber, postalCode) => {
        history.push('/quoteentry', { quoteID: jobNumber, postalCode: postalCode });
    };

    const getResultsFilteredByZipCode = useCallback((results, zipCode) => {
        if (!_.isUndefined(zipCode)) {
            return results.filter((r) => {
                const address = r.address;
                if (address && address.postalCode) {
                    const indexOfZipCode = address.postalCode.indexOf(zipCode);
                    return indexOfZipCode > -1;
                }
                return false;
            });
        }
        return results;
    }, []);

    const getResultsFilteredByState = useCallback((results, state) => {
        if (!_.isUndefined(state)) {
            return results.filter((r) => r.address.state === state);
        }
        return results;
    }, []);

    const getAddressTemplate = useCallback((address) => {
        if (_.isUndefined(address)) {
            return;
        }

        let addressDisplay = '';
        if (!_.isUndefined(address.addressLine1)) {
            addressDisplay += `${address.addressLine1}\n`;
        }
        if (!_.isUndefined(address.addressLine2)) {
            addressDisplay += `${address.addressLine2}\n`;
        }
        if (!_.isUndefined(address.addressLine3)) {
            addressDisplay += `${address.addressLine3}\n`;
        }

        addressDisplay += `${address.city}, ${address.state} ${address.postalCode}`;
        return addressDisplay;
    }, []);

    const getPoliciesTemplate = useCallback((policies) => {
        if (!_.isUndefined(policies) && policies.length > 0) {
            const policyNamesOccurrences = policies.map((policy) => MLQuoteNameUtil.getProductName(policy))
                .reduce((accumulator, currentVal) => {
                    if (accumulator[currentVal]) {
                        accumulator[currentVal]++;
                    } else {
                        accumulator[currentVal] = 1;
                    }

                    return accumulator;
                }, {});

            let result = '';

            for (const [policyType, occurrences] of Object.entries(policyNamesOccurrences)) {
                const policyTypeDisplayString = occurrences > 1 ? `${policyType}(${occurrences})` : `${policyType}`;
                result += `${policyTypeDisplayString}\n`;
            }

            return result;
        }
        return null;
    }, []);

    const getPolicyName = useCallback((item) => {
        const homeType = 'HOPLine';
        let response = '';

        if (MLQuoteNameUtil.getCoveragePartTypeName(item.policyType) !== '') {
            response = MLQuoteNameUtil.getProductName(homeType);
        } else {
            response = MLQuoteNameUtil.getProductName(item.policyType);
        }

        if (item.alternateQuoteIndicator === true) {
            response += `${translator(messages.altQuoteInd)}`;
        }

        return response;
    }, [translator]);

    const isSearchResultEmpty = () => {
        const results = searchResults.accounts;
        return _.isUndefined(results) || results.length === 0 || redirectError;
    };

    const hasOneARS = () => {
        return !_.isUndefined(legacyPolicies) && legacyPolicies.length === 1 && searchResults.arsMessage === undefined && !loading;
    };

    const deDupeAccounts = (accounts) => {
        const seen = {};
        return accounts.filter((account) => {
            if (seen.hasOwnProperty(account.accountNumber)) {
                return false;
            }
            seen[account.accountNumber] = true;
            return true;
        });
    };

    const setResultVariables = (result) => {
        let filteredSearchResults = [];
        if (isAcctNameSearch && Array.isArray(result) && result.length > 1) {
            const allAccounts = [...result[0].searchAccountDetails, ...result[1].searchAccountDetails];
            let uniqueAccounts = deDupeAccounts(allAccounts);

            // DE19602 Angular filter orderby can only sort the data on the current page if pagination is involved.
            // So need to sort the orginal data before it get to display. Use lodash sortBy function will do the job.
            // And because in this project the Lodash Version is 3.10 rather than 4. So use sortByAll function for
            // sorting with multiple sort fields.
            if (!isPortalSolrSearchEnabled && !isPortalSolrSingleTextSearchEnabled) {
                uniqueAccounts = _.sortBy(uniqueAccounts, ['lastName_ML', 'firstName_ML', 'address.state']);
            }

            uniqueAccounts = [...uniqueAccounts, ...result[3].searchHVQDetails];
            filteredSearchResults = {
                accounts: uniqueAccounts,
                message: result[0].message ? result[0].message : result[1].message,
                arsMessage: result[2].arsMessage
            };
        } else {
            filteredSearchResults = {
                accounts: result.searchAccountDetails ? result.searchAccountDetails : result.searchHVQDetails,
                policies: result.searchPolicyDetails,
                message: result.message,
                arsMessage: result.arsMessage
            };
        }
        setSearchResults(filteredSearchResults);
        copyResultsRef.current = _.cloneDeep(filteredSearchResults.accounts);
    };

    const getLOBPolicyName = useCallback((policy) => {
        return lobNames[policy.productGroupCode];
    }, []);

    const getARSAddressTemplate = useCallback((policy) => {
        if (_.isUndefined(policy.insured.address)) {
            return;
        }

        let addressDisplay = '';
        if (!_.isUndefined(policy.insured.address.addressLine1)) {
            addressDisplay += `${policy.insured.address.addressLine1}\n`;
        }
        if (!_.isUndefined(policy.insured.address.addressLine2)) {
            addressDisplay += `${policy.insured.address.addressLine2}\n`;
        }
        addressDisplay += `${policy.insured.address.city}, ${policy.governingRegionShortName}, ${policy.insured.address.postalCode}`;
        return addressDisplay;
    }, []);

    const getCurrentStateDisplay = (state) => {
        if (!_.isUndefined(state)) {
            state = translator({ id: state.name, defaultMessage: state.name })
        }
        return state;
    };

    const getStateZipCodeObj = () => {
        let stateInput;
        let zipCodeInput;
        if (stateRef.current && !_.isUndefined(stateRef.current.props)) {
            stateInput = getCurrentStateDisplay(stateRef.current.props.value);
        }
        if (zipCodeRef.current && !_.isUndefined(zipCodeRef.current.props)) {
            zipCodeInput = zipCodeRef.current.props.value;
        }
        return { state: stateInput, zipCode: zipCodeInput };
    };

    const translateState = (code) => {
        const stateCode = stateList.getCode(code);
        return translator({ id: stateCode.name, defaultMessage: stateCode.name });
    };

    const getHeaderMessage = (filteredResults, stateInput, zipCodeInput) => {
        const countLength = filteredResults ? filteredResults.length : 0;
        const searchResultEmpty = _.isUndefined(filteredResults) || filteredResults.length === 0 || redirectError;
        let header;
        if (searchResultEmpty && hasARSPolicies) {
            header = '';
        } else if (searchResultEmpty) {
            if (isJobAndZipCodeSearch) {
                header = <FormattedMessage
                    {...messages.sorryForSubmissionQuery}
                    values={{
                        countSpan: <span className={styles['search-count']}>{countLength}</span>,
                        boldSubmission: <b>{translator(messages.submissionNumber)}{searchInput || searchParam}</b>,
                        boldZipcode: <b>{`${translator(messages.zipcode)} ${zipCodeInput}`}</b>
                    }}
                />
            } else if (isAcctNameSearch && (stateInput || zipCodeInput)) {
                let values = {
                    countSpan: <span className={styles['search-count']}>{0}</span>,
                    boldQuery: <b>{searchInput || searchParam}</b>
                };
                if (stateInput && zipCodeInput) {
                    values = { ...values, boldStateZipcode: <b>{`${translateState(stateInput)} ${zipCodeInput}`}</b> };
                } else {
                    values = { ...values, boldStateZipcode: <b>{stateInput ? translateState(stateInput) : zipCodeInput}</b> };
                }
                header = <FormattedMessage
                    {...messages.sorryForxQueryInxStatexZipCode}
                    values={values}
                />
            } else if (quoteID) {
                header = <FormattedMessage
                    {...messages.sorryForxQuery}
                    values={{
                        countSpan: <span className={styles['search-count']}>{0}</span>,
                        boldQuery: <b>{quoteID}</b>
                    }}
                />
            } else {
                header = <FormattedMessage
                    {...messages.sorryForxQuery}
                    values={{
                        countSpan: <span className={styles['search-count']}>{0}</span>,
                        boldQuery: <b>{searchInput || searchParam}</b>
                    }}
                />
            }
        } else if (isJobAndZipCodeSearch) {
            header = <FormattedMessage
                {...messages.xCountMatchesForSubmissionxQuery}
                values={{
                    countSpan: <span className={styles['search-count']}>{countLength}</span>,
                    boldSubmission: <b>{translator(messages.submissionNumber)}{searchInput || searchParam}</b>,
                    boldZipcode: <b>{`${translator(messages.zipcode)} ${zipCodeInput}`}</b>
                }}
            />
        } else if (isAcctNameSearch && (stateInput || zipCodeInput)) {
            let values = {
                countSpan: <span className={styles['search-count']}>{countLength}</span>,
                query: <>{searchInput || searchParam}</>
            };
            if (stateInput && zipCodeInput) {
                values = { ...values, boldStateZipcode: <b>{`${translateState(stateInput)} ${zipCodeInput}`}</b> }
            } else {
                values = { ...values, boldStateZipcode: <b>{stateInput ? translateState(stateInput) : zipCodeInput}</b> }
            }
            header = <FormattedMessage
                {...messages.xCountMatchesForxQueryInxStatexZipCode}
                values={values}
            />
        } else {
            header = <FormattedMessage
                {...messages.xCountMatchesForxQuery}
                values={{
                    countSpan: <span className={styles['search-count']}>{countLength}</span>,
                    boldQuery: <b>{searchInput || searchParam}</b>
                }}
            />
        }
        return header;
    };

    const isHVQSearch = () => {
        return isCompIDSearch || isHVQNumExactSearch;
    };

    const convertLocalDateToDate = useCallback((localDate) => {
        const parsedDate = new Date(localDate.year, localDate.month, localDate.day);
        return moment(parsedDate).format('MM/DD/YYYY');
    }, []);

    const redirectURL = useCallback((policy) => {
        let redirectUrl = '';
        const itemNumber = policy.productGroupCode + policy.policyID + policy.policySuffixID;
        redirectUrl = policy.redirectUrl.replace('*', itemNumber);
        window.open(redirectUrl, '_blank');
    }, []);

    const redirectURLEvt = useCallback((event, policy) => {
        event.preventDefault();
        redirectURL(policy);
    }, [redirectURL]);

    const goToARSPoliciesPage = useCallback(() => {
        history.push({
            pathname: `/searchArs/${searchRequest.value.name_ML}`,
            state: { legacyPolicies: legacyPolicies, searchParam: searchRequest.value.name_ML, forceReload: forceReload }
        });
    }, [history, legacyPolicies, searchRequest.value.name_ML, forceReload]);

    const isDobMasked = (dob) => {
        return dob !== undefined && dob.year === 0;
    };

    const getMaskedDate = (dob) => {
        const month = dob.month < 9 ? `0${dob.month + 1}` : `${dob.month + 1}`;
        const day = dob.day < 10 ? `0${dob.day}` : `${dob.day}`;
        return `${month}/${day}/XXXX`;
    };

    const getDobDisplayValue = (dob) => {
        return isDobMasked(dob) ? getMaskedDate(dob) : convertLocalDateToDate(dob);
    };

    const parseErrorForMessage = (error) => {
        const errorMessageStringArray = error.baseError.split(' ');
        const outerErrorCodeIndex = error.baseError.indexOf('ErrorCode:');
        const outerErrorCodeValue = outerErrorCodeIndex !== -1 ? errorMessageStringArray[outerErrorCodeIndex + 1] : undefined;
        const outerErrorCodeNumericValue = !_.isUndefined(outerErrorCodeValue) ? parseInt(outerErrorCodeValue, 10) : undefined;

        let errorMessage;

        if (outerErrorCodeNumericValue === appConfig.errorCodes.DISPLAYABLE_ERROR_ML) {
            const errorString = error.baseError;
            const indexOfMessages = errorString.indexOf('Messages_ML');
            let errorMessages = errorString.substring(indexOfMessages).split(']')[0];
            errorMessages = errorMessages.split('[')[1];
            errorMessage = errorMessages.split(',')[0];
        }

        return errorMessage;
    };

    const handleBridgingError = (quoteId, error) => {
        const title = translator(messages.errorBridgingOperation);
        let description = translator(messages.errorBridgingxID, { quoteId });
        const errorMessage = parseErrorForMessage(error);
        console.error(error);

        if(!_.isUndefined(errorMessage)) {
            description = errorMessage;
        }

        showErrorModal(title, description);
    };

    const handleBridgingRequest = (hvqTransactionId, hvqBridgingCall) => {
        const bridgePromise = hvqBridgingCall();
        showProgressDialog(messages.bridgingInProgress, bridgePromise);
        bridgePromise.then((hvqRes) => {
            if (!_.isUndefined(hvqRes)) {
                MLStateRolloutService.checkIsCRWizardEligible(hvqRes.jobID, authHeader).then((isCRWizardEligible) => {
                    if (isCRWizardEligible) {
                        history.push('/quoteentry', { account: hvqRes.accountNumber, quoteID: hvqRes.jobID });
                    }else{
                        history.push(`/accounts/${hvqRes.accountNumber}/summary`, {
                            accountNumber: hvqRes.accountNumber,
                            bridgedQuoteNumber: hvqRes.jobID
                        });
                    }
                }).catch(() => {
                    // Error determining if User has access to CompRater Wizard. Assume no.
                    history.push(`/accounts/${hvqRes.accountNumber}/summary`, {
                        accountNumber: hvqRes.accountNumber,
                        bridgedQuoteNumber: hvqRes.jobID
                    });
                })
                    .finally(() => {
                        setShowModal(false);
                    })
            } else {
                handleBridgingError(hvqTransactionId);
            }

        }, (error) => {
            handleBridgingError(hvqTransactionId, error);
        });
    };

    const createNewAccount = (hvqTransactionId) => {
        handleBridgingRequest(hvqTransactionId, () => MLHVQBridgeService.createFromHVQTransactionIdOnNewAccount(hvqTransactionId, authHeader));
    };

    const getPotentialAccountsModal = () => {
        const potentialAccountsOverrideProps = () => {
            const getSuffixName = (suffixCode) => {
                const nameSuffixList = viewModelService.productMetadata.get('pc').types.getTypelist('NameSuffix');
                const suffixTypeKeyName = nameSuffixList.getCode(suffixCode).name;
                const suffixDisplayName = translator(
                    {
                        id: suffixTypeKeyName,
                        defaultMessage: ' '
                    }
                );
                return suffixDisplayName;
            };

            const getFullName = (accountHolder) => {
                const middleName = accountHolder.middleName || '';
                const suffix = accountHolder.suffix ? getSuffixName(accountHolder.suffix) : '';
                return `${accountHolder.firstName} ${middleName} ${accountHolder.lastName} ${suffix}`;
            };

            const overrides = potentialExistingAccounts.map((account, index) => {

                const goToAccountSummary = () => {
                    const accountSummaryPath = `producer-engage/accounts/${account.accountNumber}/summary`;
                    const url = `${window.location.origin}/${accountSummaryPath}`;
                    window.location.href = url;
                };

                const startNewQuote = () => {
                    handleBridgingRequest(hvqTransactionId,
                        () => MLHVQBridgeService.createFromHVQTransactionIdOnExistingAccount(hvqTransactionId, account.accountNumber, authHeader)
                    );
                    return true;
                };

                return {
                    [`accountNumberLink${index}`]: {
                        onClick: goToAccountSummary,
                        content: _.capitalize(getFullName(account.accountHolder))
                    },
                    [`autoProduct${index}`]: {
                        visible: !_.isUndefined(account.numberOfAutoProducts_ML) && account.numberOfAutoProducts_ML > 0,
                        content: translator(mlAccountsModalMessages.numberOfProductsAuto, { numberOfProducts: account.numberOfAutoProducts_ML })
                    },
                    [`homeProduct${index}`]: {
                        visible: !_.isUndefined(account.numberOfHomeProducts_ML) && account.numberOfHomeProducts_ML > 0,
                        content: translator(mlAccountsModalMessages.numberOfProductsHome, { numberOfProducts: account.numberOfHomeProducts_ML })
                    },
                    [`umbrellaProduct${index}`]: {
                        visible: !_.isUndefined(account.numberOfUmbrellaProducts_ML) && account.numberOfUmbrellaProducts_ML > 0,
                        content: translator(mlAccountsModalMessages.numberOfProductUmbrella, { numberOfProducts: account.numberOfUmbrellaProducts_ML })
                    },
                    [`address${index}`]: {
                        content: _.get(account, 'accountHolder.primaryAddress.displayName', '')
                    },
                    [`phone${index}`]: {
                        content: _.get(account, 'accountHolder.maskedPrimaryPhoneNumber_ML', '')
                    },
                    [`selectButton${index}`]: {
                        onClick: startNewQuote
                    }
                };
            });

            return Object.assign({}, ...overrides);
        };

        const overrides = {
            possibleAccountsHeader: {
                visible: false,
            },
            potentialAccountsIterable: {
                data: potentialExistingAccounts
            },
            ...potentialAccountsOverrideProps()
        };

        const componentProps = {
            title: translator(mlAccountsModalMessages.existingCustomersHeader),
            uiProps: mlPossibleAccountsModal.componentContent,
            actionBtnLabel: mlAccountsModalMessages.addNewCustomerButton,
            viewModel: {},
            additionalPEStyle: 'customPossibleAccountsModal',
            modalBodyStyles: mlAccountsModalStyles,
            overrideProps: overrides,
            onSaveAction: () => {
                createNewAccount(hvqTransactionId);
                return true;
            },
            removeSidesPadding: true,
            messageNextToButton: translator(mlAccountsModalMessages.noneAreMatch),
            buttonType: 'filled',
            isOpen: showModal,
            onCancelAction: () => setShowModal(false)
        };

        return (
            <FormModalPopover {...componentProps} />
        );
    };

    const onBridgeClick = (account) => {
        const hvqTransactionId = account.transactionID;
        if (Array.isArray(account.matchingAccounts) && account.matchingAccounts.length > 0) {
            setPotentialExistingAccounts(account.matchingAccounts);
            setHvqTransactionId(hvqTransactionId);
            setShowModal(true);
        } else {
            createNewAccount(hvqTransactionId);
        }
    };

    const handleTakeOverError = (quoteId, error) => {
        const title = translator(messages.errorInTakeOverOperation);
        const description = translator(messages.unableToTakeOverxID, { quoteId });
        console.error(error);
        showErrorModal(title, description);
    };

    const takeOverQuote = (quoteId, zipCode) => {
        const takeoverPromise = LoadSaveService.takeOverSubmission(quoteId, zipCode, authHeader);
        showProgressDialog(messages.loading, takeoverPromise);
        takeoverPromise.then((submissionRes) => {
            if (!_.isUndefined(submissionRes)) {
                redirectQuote(submissionRes.quoteID, submissionRes.baseData.policyAddress.postalCode);
            } else {
                handleTakeOverError(quoteId);
            }
        }, (error) => {
            handleTakeOverError(quoteId, error);
        });
    };

    const onSearchError = (error) => {
        searchError = error
    }

    const processSearchResults = (searchPromise) => {
        setRedirectError(false);
        searchPromise.then((searchResult) => {
            if (isJobAndZipCodeSearch) {
                try {
                    takeOverQuote(searchResult.searchQuoteRetrieval.quoteID, searchResult.searchQuoteRetrieval.postalCode);
                } catch (e) {
                    setRedirectError(true);
                    setLoading(false);
                }
            } else if ((isPolicySearch && searchResult.searchAccountDetails?.length) || (isPolicyNumSingleExactSearch && searchResult.searchAccountDetails?.length)) {
                const policyNumberToView = searchResult.searchAccountDetails[0].searchResultPolicyNumber;
                goToPolicySummaryPage(policyNumberToView);
            } else if ((isJobSearch) || (isJobNumSingleExactSearch)) {
                if (searchResult.searchAccountDetails?.length) {
                    const jobNumber = searchResult.searchAccountDetails[0].searchResultJobNumber;
                    const accountNumber = searchResult.searchAccountDetails[0].accountNumber;
                    const postalCode = searchResult.searchAccountDetails[0].searchResultJobPostalCode;
                    const bundledInd = searchResult.searchAccountDetails[0].searchResultJobBundledInd;
                    const isBookroll = searchResult.searchAccountDetails[0].searchResultJobBookrollIndicator === 'With Rate Capping' || searchResult.searchAccountDetails[0].searchResultJobBookrollIndicator === 'Without Rate Capping';
                    const isWithRateCapping = searchResult.searchAccountDetails[0].searchResultJobBookrollIndicator === 'With Rate Capping';
                    const jobStatus = searchResult.searchAccountDetails[0].searchResultJobStatus;
                    const isAlaska7Day = searchResult.searchAccountDetails[0].address.state === 'AK' && searchResult.searchAccountDetails[0].searchResultJobTerm === '7 days';
                    if (bundledInd) {
                        if (jobStatus !== 'Bound') {
                            MLBundleService.checkIsCRBridgedQuote(jobNumber, authHeader)
                                .then((isCRBridgeQuote) => {
                                    if(isCRBridgeQuote && isCRBridgeQuote.length > 0) {
                                        // Check state rollout eligible
                                        return MLStateRolloutService.checkIsCRWizardEligible(jobNumber, authHeader)
                                            .then((isCREligible) => {
                                                if(isCREligible) {
                                                    const quoteEntryInfo = {
                                                        account: accountNumber,
                                                        quoteID: jobNumber,
                                                        postalCode: postalCode
                                                    };
                                                    history.push('/quoteentry', quoteEntryInfo);
                                                } else {
                                                    if (isBookroll) {
                                                        MLBundleService.loadBundleCart(accountNumber, history);
                                                    } else {
                                                        MLBundleService.updateBundleAndGotoAgentBundleCart(accountNumber, jobNumber, showProgressDialog, viewModelService, showErrorModal, history, authHeader);
                                                    }
                                                }
                                            })
                                    } else {
                                        if (isBookroll) {
                                            MLBundleService.loadBundleCart(accountNumber, history);
                                        } else {
                                            MLBundleService.updateBundleAndGotoAgentBundleCart(accountNumber, jobNumber, showProgressDialog, viewModelService, showErrorModal, history, authHeader);
                                        }
                                    }
                                });
                        } else {
                            goToQuote(jobNumber, postalCode);
                        }
                    } else if (isWithRateCapping || isAlaska7Day) {
                        if (jobStatus === 'Quoted') {
                            history.push('/quoteentry', { quoteID: jobNumber, postalCode: postalCode });
                        } else {
                            const modalTitle = translator(messages.quoteIsNotComplete);
                            let modalMsg = '';

                            if (isWithRateCapping) {
                                modalMsg = translator(messages.contactBookConsolidationManager);
                            } else if (isPCSorIA) {
                                modalMsg = translator(messages.contactForAssistance);
                            } else {
                                modalMsg = translator(messages.quoteMustCompleteInPC);
                            }

                            showErrorModal(modalTitle, modalMsg, messages.close);
                            setLoading(false);
                        }
                    } else if (jobStatus !== 'Bound') {
                        const componentProps = {
                            title: mlBundleQuestionPopupMsg.savedQuote,
                            overrideProps: {
                                accountNumber: accountNumber,
                                quoteNumber: jobNumber,
                                postalCode: postalCode,
                                history,
                                viewModelService,
                                onError: onSearchError,
                                authHeader
                            },
                            CustomComponent: mlBundleQuestionPopup,
                            showFooterOnCustomComponent: false,
                            additionalPEStyle: 'customFooterModal',
                        };

                        modalApi.showModal(
                            <FormModalPopover {...componentProps} />
                        ).then(_.noop, () => {
                            if (searchError) {
                                // do not display searchError to match v9
                                history.push('/contactUs');
                                searchError = undefined;
                            }
                        });
                    } else {
                        goToQuote(jobNumber, postalCode);
                    }
                } else if (isPortalSolrSingleTextSearchEnabled) {
                    let searchPolPromise;

                    isJobNumSingleExactSearch = false;
                    isHVQNumExactSearch = false;
                    isPolicyNumSingleSolrSearch = true;

                    const searchPolNumRequest = createSearchRequest();

                    searchPolNumRequest.name_ML = searchParam;
                    searchPolNumRequest.searchParam = null;

                    searchPolPromise = SearchService.searchByPolicyName(searchPolNumRequest.value, authHeader);

                    showProgressDialog(platformMessages.loading, searchPolPromise);
                    processSearchResults(searchPolPromise);

                } else {
                    setResultVariables(searchResult);
                    setLoading(false);
                }
            } else if (isAcctNameSearch  && !isPolicyNumSingleSolrSearch && !isHVQNumExactSearch && !isPolicyNumSingleExactSearch && !isJobNumSingleExactSearch) {
                const searchedLegacyPolicies = searchResult[LEGACY_SEARCH_INDEX].searchLegacyPolicies;

                setLegacyPolicies(searchedLegacyPolicies);

                if (searchedLegacyPolicies.length !== 0) {
                    setHasARSPolicies(true);
                }

                setResultVariables(searchResult);
                setLoading(false);
            } else {
                setResultVariables(searchResult);
                setLoading(false);
            }

            const zipcode = searchRequest?.zipCode_ML?.value || getStateZipCodeObj().zipCode;

            setSearchHeader(getHeaderMessage(copyResultsRef.current, getStateZipCodeObj().state, zipcode));
            MLTagManagerService.sendSearchEvent(translator({ id: MLSearchDataHolderService.getSearchType().name, defaultMessage: MLSearchDataHolderService.getSearchType().name }));
        }).catch((error) => {
            console.error(error);
            showErrorModal(platformMessages.error, translator(messages.searchError));
            setLoading(false);
        });
    };

    const setSingleSearchType = (request) => {
        request.name_ML = request.name_ML?.trim();

        isPolicyNumSingleExactSearch = false;
        isJobNumSingleExactSearch = false;
        isHVQNumExactSearch = false;
        isPolicyNumSingleSolrSearch = false;

        const policyNumRegex = /^[a-zA-Z]\d{10}$/;
        const jobNumRegex = /^\d{10}$/;
        const hvqNumRegex = /^[Hh][Vv][Qq]/

        isPolicyNumSingleExactSearch = policyNumRegex.test(request.name_ML)

        isJobNumSingleExactSearch = jobNumRegex.test(request.name_ML)

        isHVQNumExactSearch = hvqNumRegex.test(request.name_ML)

        if (isPolicyNumSingleExactSearch || isHVQNumExactSearch) {
            request.name_ML = request.name_ML?.toUpperCase();
        }

        if (isPolicyNumSingleExactSearch || isJobNumSingleExactSearch || isHVQNumExactSearch)  {
            request.searchParam = request.name_ML
            request.name_ML = null
        }
    }

    const performSearch = (request) => {
        let searchPromise;
        setPageConfig(prev => ({ ...prev, page: 0 }));

        MLPortalSettingsService.getSettings(authHeader).then((response) => {
            if (response) {
                if (response.enablePortalSolrSearch) {
                    isPortalSolrSearchEnabled = true;
                }

                if (response.enablePortalSolrSingleTextSearch) {
                    isPortalSolrSingleTextSearchEnabled = true;
                    setSingleSearchType(request);
                }

                if (isAcctNameSearch && !isPolicyNumSingleExactSearch && !isJobNumSingleExactSearch && !isHVQNumExactSearch) {
                    searchPromise = Promise.all([SearchService.searchByName(request, authHeader), SearchService.searchByPolicyName(request, authHeader), SearchService.searchByARSPoliciesML(request, authHeader), SearchService.searchHVQByName(request, authHeader)]);
                } else if (isPolicySearch || isPolicyNumSingleExactSearch) {
                    searchPromise = SearchService.searchByPolicyNumber(request, authHeader);
                } else if (isJobSearch || isJobNumSingleExactSearch) {
                    searchPromise = SearchService.searchBySubmissionNumber_Ext(request, authHeader);
                } else if (isCompIDSearch || isHVQNumExactSearch) {
                    searchPromise = SearchService.searchHVQByQuoteId(request, authHeader);
                } else if (isJobAndZipCodeSearch) {
                    searchPromise = SearchService.searchByJobAndZipCodeWithRestrictions(request, authHeader);
                } else {
                    console.error(new Error('Could not process search due to non-specified search method'));

                    return;
                }

                showProgressDialog(platformMessages.loading, searchPromise);
                processSearchResults(searchPromise);
            }
        });
    };

    const writeValue = useCallback((value, path) => {
        const newSearchRequestVM = viewModelService.clone(searchRequest);
        _.set(newSearchRequestVM, path, value);
        setSearchRequest(newSearchRequestVM);
    }, [searchRequest, viewModelService]);

    useEffect(() => {
        // object needs to be cleared because when another search is initiated we don't want the previous
        // state and/or zipcode automatically populating when creating the search request
        if (initSearchBtnClicked) {
            clearMLSearchDataHolderService();
            const newSearchRequest = createSearchRequest();
            setSearchRequest(newSearchRequest);
            performSearch(newSearchRequest.value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initSearchBtnClicked]);

    const handleZipCodeBlur = () => {
        let newVal = zipCodeRef.current.props.value;
        if (!_.isUndefined(newVal) && !newVal.includes('-') && newVal.length > 5) {
            const first5Digits = newVal.substring(0, 5);
            const last4Digits = newVal.substring(5);
            newVal = `${first5Digits}-${last4Digits}`;
            writeValue(newVal, 'zipCode_ML.value');
        }
        const resultsToFilter = getResultsFilteredByState(copyResultsRef.current, stateRef.current.props.value);
        const filteredResultsByZipcode = getResultsFilteredByZipCode(resultsToFilter, newVal);
        setDataToDisplay(filteredResultsByZipcode);
        setSearchHeader(getHeaderMessage(filteredResultsByZipcode, getCurrentStateDisplay(stateRef.current.props.value), newVal));
    };

    const handleStateChange = (newVal) => {
        writeValue(newVal, 'state_ML.value');
        const resultsToFilter = getResultsFilteredByZipCode(copyResultsRef.current, zipCodeRef.current.props.value);
        const filteredResultsState = getResultsFilteredByState(resultsToFilter, newVal);
        setDataToDisplay(filteredResultsState);
        setSearchHeader(getHeaderMessage(filteredResultsState, newVal, zipCodeRef.current.props.value));
    };

    const renderUserInfoCell = (item) => {
        return (
            <div className={styles['userinfo-cell']}>
                <div className={styles['user-icon']}>
                    {
                        (item.gender === 'F') ? <Image src={bustfemale} alt="" /> : <Image src={bustmale} alt="" />
                    }
                </div>
                <div className={styles['accountinfo-cell']}>
                    <h2 className={styles['account-name']}>
                        {MLCapitalizeStringFilter.capitalize(item.name)}
                    </h2>
                    <p className={classNames(styles.secondary, "light", "font-weight-bold")}>
                        {`${translator(messages.DOB)} ${getDobDisplayValue(item.dateOfBirth)}`}
                        {
                            (isInitPortalSolrSingleTextSearchEnabled === true && item.additionalName)?
                                <div>
                                    <TooltipIcon
                                        icon="mi-person"
                                        text={item.additionalName}
                                        title="Additional Insured"
                                        className="app__MLSearchResults__icon-md"
                                    />
                                </div>
                                :""
                        }
                    </p>
                </div>
            </div>
        )
    };

    const renderAddressCell = (item) => {
        return (
            <>
                <p className={classNames(styles['body-copy'], "light", "font-weight-bold")}>{translator(messages.address)}</p>
                <p className={styles['body-copy']}>
                    {getAddressTemplate(item.address)}
                </p>
            </>
        )
    };

    const renderPhoneCell = (item) => {
        return (
            <>
                <p className={classNames(styles['body-copy'], "light", "font-weight-bold")}>{translator(messages.phone)}</p>
                <p className={styles['body-copy']}>
                    {MLPhoneFormatUtil.formatPhone(item.contactNumber)}
                </p>
            </>
        )
    };

    const renderSelectCell = (item) => {
        return (
            <div>
                <Button mlTagManagerLinkClick="AgentSearchResult_Select" onClick={() => goToSummaryPage(item)} type="outlined">
                    {_.upperCase(translator(messages.select))}
                </Button>
            </div>
        )
    };

    const renderActLineOfBusinessCell = (item) => {
        return (
            <>
                <p className={classNames(styles['body-copy'], "light", "font-weight-bold")}>{translator(messages.lineOfBusiness)}</p>
                <p className={styles['body-copy']}>{getPolicyName(item)}{}</p>
            </>
        )
    };

    const renderThirdColumn = (item) => {
        if (item.compRaterName) {
            return renderActLineOfBusinessCell(item);
        }
        return renderPhoneCell(item);
    };

    const renderActPoliciesCell = (item) => {
        return (
            <>
                <p className={classNames(styles['body-copy'], "light", "font-weight-bold")}>{translator(messages.policies)}</p>
                <p className={styles['body-copy']}>{getPoliciesTemplate(item.policies)}</p>
            </>
        )
    };

    const getTimeStamp = (item)=>{
        return toLocaleTimeStamp(item.createTimeStamp)
    }

    const renderActCompRaterCell = (item) => {
        return (
            <>
                <grid>
                    <div>
                        <p className={classNames(styles['body-copy'], "light", "font-weight-bold")}>{translator(messages.compRater)}</p>
                        <p className={styles['body-copy']}>{item.compRaterName}</p>
                    </div>
                    <div>
                        <p className={classNames(styles['body-copy'], "light", "font-weight-bold")}>{translator(messages.timeStamp)}</p>
                        <p className={styles['body-copy']}>{getTimeStamp(item)}</p>
                    </div>

                </grid>
            </>
        )
    };

    const renderFourthColumn = (item) => {
        if (item.compRaterName) {
            return renderActCompRaterCell(item);
        }
        return renderActPoliciesCell(item);
    };

    const renderActBridgeCell = (item) => {
        return (
            <div>
                {
                    item.isBridged ? (
                        <p className={styles['body-copy']}>{translator(messages.quoteBridged)}</p>
                    ) : (
                        <Button type="filled" onClick={() => onBridgeClick(item)}>
                            {translator(messages.bridge)}
                        </Button>
                    )
                }
            </div>
        )
    };

    const renderButtonColumn = (item) => {
        if (item.compRaterName) {
            return renderActBridgeCell(item);
        }
        return renderSelectCell(item);
    };

    const renderARSNameCell = (item) => {
        return (
            <div className={styles['arsName-col']}>
                <h2 className={classNames(styles['account-name'], "font-weight-bold")}>{MLCapitalizeStringFilter.capitalize(item.insured.fullName)}</h2>
            </div>
        )
    };

    const renderARSAccountHolderCell = (item) => {
        return (
            <>
                <p className={classNames(styles['body-copy'], "light", "font-weight-bold")}>{translator(messages.accountHolder)}</p>
                <p className={classNames(styles['body-copy'], "font-weight-bold")}>{item.insured.fullName}</p>
            </>
        )
    };

    const renderARSAddressCell = (item) => {
        return (
            <>
                <p className={classNames(styles['body-copy'], "light", "font-weight-bold")}>{translator(messages.address)}</p>
                <p className={styles['body-copy']}>{getARSAddressTemplate(item)}</p>
            </>
        )
    };

    const renderARSPhoneCell = (item) => {
        return (
            <>
                <p className={classNames(styles['body-copy'], "light", "font-weight-bold")}>{translator(messages.phone)}</p>
                <p className={styles['body-copy']}>{MLPhoneFormatUtil.formatPhone(item.insured.phone)}</p>
            </>
        )
    };

    const renderARSLineOfBusinessCell = (item) => {
        return (
            <>
                <p className={classNames(styles['body-copy'], "light", "font-weight-bold")}>{translator(messages.lineOfBusiness)}</p>
                <p className={styles['body-copy']}>
                    <Link href="/" onClick={(event) => redirectURLEvt(event, item)}>
                        {`${getLOBPolicyName(item)} - ${item.policyID}`}
                    </Link>
                </p>
                <p><span className="ml-pill ml-pill-default">{translator(messages.ARS)}</span></p>
            </>
        )
    };

    const renderARSSelectCell = (item) => {
        return (
            <div>
                <Button onClick={() => redirectURL(item)} type="outlined">
                    {_.upperCase(translator(messages.select))}
                </Button>
            </div>
        )
    };

    const getAvailableStates = useMemo(() => {
        const states = initSearchRequest.state_ML.aspects.availableValues;
        return states.map((type) => {
            return {
                code: type.code,
                name: translator({
                    id: type.name,
                    defaultMessage: type.name
                })
            };
        });
    }, [initSearchRequest.state_ML.aspects.availableValues, translator]);

    const overrideProps = {
        searchResultTitle: {
            visible: !loading,
            content: searchHeader
        },
        searchResultFilter: {
            visible: isAcctNameSearch
        },
        zipCodeInput: {
            ref: zipCodeRef,
            value: searchRequest.zipCode_ML.value,
            path: 'zipCode_ML.value',
            onValueChange: writeValue,
            onBlur: handleZipCodeBlur,
            onValidationChange: onValidate,
            showErrors: !searchRequest.zipCode_ML.aspects.valid || !searchRequest.zipCode_ML.aspects.subtreeValid,
            validationMessages: searchRequest.zipCode_ML.aspects.validationMessages
        },
        stateInput: {
            ref: stateRef,
            value: searchRequest.state_ML.value,
            availableValues: getAvailableStates,
            onValueChange: (value) => handleStateChange(value)
        },
        searchingTextContainer: {
            visible: loading
        },
        loadingIndicator: {
            loaded: !loading
        },
        searchResultWarningbox: {
            visible: !_.isUndefined(searchResults.message) && copyResultsRef.current.length > 100,
            message: searchResults.message
        },
        searchResultContentBox: {
            visible: !isSearchResultEmpty() && !loading
        },
        accountResultDataTable: {
            pageSizeOptions: [MAX_SEARCH_RESULT_DISPLAY],
            defaultConfig: { "pageSize": MAX_SEARCH_RESULT_DISPLAY, "page": 0 },
            config: pageConfig,
            onConfigChange: (config)=>{setPageConfig(config)},
            showPagination: true,
            data: searchResults.accounts
        },
        hvqAccountResultDataTable: {
            pageSizeOptions: [MAX_SEARCH_RESULT_DISPLAY],
            defaultConfig: { "pageSize": MAX_SEARCH_RESULT_DISPLAY, "page": 0 },
            showPagination: true,
            data: searchResults.hvqAccounts
        },
        ARSPoliciesHeaderContainer: {
            visible: !hasOneARS() && hasARSPolicies
        },
        foundMultiARSInfo: {
            content: <FormattedMessage
                {...messages.weHaveFoundxARSPoliciesForx}
                values={{
                    countSpan: <span className={styles['search-count']}>{legacyPolicies.length}</span>,
                    strongARS: <strong>{translator(messages.ARS)}</strong>,
                    strongName: <strong>{searchRequest.value.name_ML}</strong>
                }}
            />
        },
        foundHVQInfo: {
            content: <FormattedMessage
                {...messages.weHaveFoundxARSPoliciesForx}
                values={{
                    countSpan: <span className={styles['search-count']}>{legacyPolicies.length}</span>,
                    strongARS: <strong>{translator(messages.ARS)}</strong>,
                    strongName: <strong>{searchRequest.value.name_ML}</strong>
                }}
            />
        },
        ARSPoliciesContainer: {
            visible: hasOneARS()
        },
        foundOneARSInfo: {
            content: <FormattedMessage
                {...messages.weHaveFoundOneARSPolicyFor}
                values={{
                    countSpan: <span className={styles['search-count']}>1</span>,
                    strongName: <strong>{searchRequest.value.name_ML}</strong>
                }}
            />
        },
        foundOneComprater: {
            content: <FormattedMessage
                {...messages.weHaveFoundOneCompraterQuote}
                values={{
                    countSpan: <span className={styles['search-count']}>1</span>,
                    strongName: <strong>{searchRequest.value.name_ML}</strong>
                }}
            />
        },
        legacyPolicyDataTable: {
            data: legacyPolicies
        },
        ARSPoliciesMsgContainer: {
            visible: !hasARSMessage && (searchResults.arsMessage !== undefined)
        },
        ARSPoliciesMsg: {
            content: <FormattedMessage
                {...messages.weAreUnableToRetrieveARSPolicy}
                values={{
                    strongARS: <strong>{translator(messages.ARS)}</strong>
                }}
            />
        },
        searchTipsContainer: {
            visible: hasARSMessage && isSearchResultEmpty() && !loading && !hasARSPolicies && isInitPortalSolrSingleTextSearchEnabled === false
        },
        singleSolarSearchTipsContainer:{
            visible: hasARSMessage && isSearchResultEmpty() && !loading && !hasARSPolicies && isInitPortalSolrSingleTextSearchEnabled === true
        },
        nonHVQSearchTipsContainer: {
            visible: !isHVQSearch()
        },
        nonPolicySearchTipsLi5: {
            visible: isJobAndZipCodeSearch
        },
        HVQSearchTipsContainer: {
            visible: isHVQSearch()
        },
        nonARSPolicyMsgContainer: {
            visible: !hasARSPolicies && isAcctNameSearch && !loading
        },
        nonARSPolicyMsg: {
            content: <FormattedMessage
                {...messages.weHaveFoundxARSPoliciesForx}
                values={{
                    countSpan: <span className={styles['search-count']}>{legacyPolicies.length}</span>,
                    strongARS: <strong>{translator(messages.ARS)}</strong>,
                    strongName: <strong>{searchRequest.value.name_ML}</strong>
                }}
            />
        },
        arsTipsContainer: {
            visible: hasARSMessage
        }

    };

    const resolvers = {
        resolveCallbackMap: {
            renderUserInfoCell,
            renderAddressCell,
            renderPhoneCell,
            renderSelectCell,
            renderActLineOfBusinessCell,
            renderThirdColumn,
            renderFourthColumn,
            renderButtonColumn,
            renderActPoliciesCell,
            renderActCompRaterCell,
            renderActBridgeCell,
            goToARSPoliciesPage,
            renderARSNameCell,
            renderARSAccountHolderCell,
            renderARSAddressCell,
            renderARSPhoneCell,
            renderARSLineOfBusinessCell,
            renderARSSelectCell
        },
        resolveClassNameMap: styles
    };

    return (
        <React.Fragment>
            <ViewModelForm
                uiProps={metadata.pageContent}
                overrideProps={overrideProps}
                classNameMap={resolvers.resolveClassNameMap}
                callbackMap={resolvers.resolveCallbackMap}
            />
            {getPotentialAccountsModal(searchResults.accounts, searchRequest.value.name_ML)}
        </React.Fragment>
    );
}

MLSearchResults.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            searchParam: PropTypes.string,
            quoteID: PropTypes.string
        })
    }),
    history: PropTypes.shape({
        push: PropTypes.func
    })
};

export default withRouter(withAuthenticationContext(withViewModelService(MLSearchResults)));